module.exports = __webpack_public_path__ + "u11.no2.ab0828e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u11.no2.jpg
// module id = 9/hs
// module chunks = 0